import { Card, Row, Col, Spin, theme } from 'antd';
import { useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { DashboardStateType } from '../../Services/DashboardService';
import DashBoardStatsModel from './StatsModals/DashBoardStatsModel';
import { usePractice } from '../../Context/PracticeContext';
interface cardProps {
  id: string;
  title: string;
  value: string | number;
  icon?: React.ReactNode;
  hoverable?: boolean;
  extra?: React.ReactNode;
  loading?: boolean;
  fromDate: string,
  toDate: string
}

const HeaderCard = ({
  id,
  title,
  value,
  icon,
  hoverable = true,
  extra,
  loading = false,
  fromDate,
  toDate
}: cardProps) => {
  const { token } = theme.useToken();
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const { allPracticeIds } = usePractice();
  const isLiveURL = window.location.origin === "https://admin.actingoffice.com";

  const removePractice = new Set([6, 10]);
  const filteredPracticeIds = isLiveURL ? allPracticeIds?.filter((p) => !removePractice.has(p.value)) : allPracticeIds;

  console.log("filteredPracticeIds", filteredPracticeIds)

  const renderModal = () => {
    switch (activeModal) {
      case "incoming":
        return <DashBoardStatsModel
          modelType={DashboardStateType.IncommingCalls}
          open
          onCancel={() => setActiveModal(null)}
          fromDate={fromDate}
          toDate={toDate}
          filteredPracticeIds={filteredPracticeIds}
          modelTitle="Incomming Stats"
          tableTitle="Incomming Calls"
          align="start"
        />;
      case "outgoing":
        return <DashBoardStatsModel
          modelType={DashboardStateType.OutgoingCalls}
          open
          onCancel={() => setActiveModal(null)}
          fromDate={fromDate}
          toDate={toDate}
          filteredPracticeIds={filteredPracticeIds}
          modelTitle="Outgoing Stats"
          tableTitle="Outgoing Calls"
          align="start"
        />;
      case "emails":
        return <DashBoardStatsModel
          modelType={DashboardStateType.Emails}
          open
          onCancel={() => setActiveModal(null)}
          fromDate={fromDate}
          toDate={toDate}
          filteredPracticeIds={filteredPracticeIds}
          modelTitle="Email Stats"
          tableTitle="Emails"
          align="start" />;
      case "storageUses":
        return <DashBoardStatsModel
          modelType={DashboardStateType.StorageUses}
          open
          onCancel={() => setActiveModal(null)}
          fromDate={fromDate}
          toDate={toDate}
          filteredPracticeIds={filteredPracticeIds}
          modelTitle="Storage Uses Stats"
          tableTitle="Storage Uses"
          align="start"
        />;
      case "invoice":
        return <DashBoardStatsModel
          modelType={DashboardStateType.InvoicesAmount}
          open
          onCancel={() => setActiveModal(null)}
          fromDate={fromDate}
          toDate={toDate}
          filteredPracticeIds={filteredPracticeIds}
          modelTitle="Invoices Stats"
          tableTitle="Invoice Amount"
          align="end"
        />;
      case "receipts":
        return <DashBoardStatsModel
          modelType={DashboardStateType.ReceiptAmount}
          open
          onCancel={() => setActiveModal(null)}
          fromDate={fromDate}
          toDate={toDate}
          filteredPracticeIds={filteredPracticeIds}
          modelTitle="Receipt Stats"
          tableTitle="Receipt Amount"
          align="end"
        />;
      case "stripe":
        return <DashBoardStatsModel
          modelType={DashboardStateType.StriptAmount}
          open
          onCancel={() => setActiveModal(null)}
          fromDate={fromDate}
          toDate={toDate}
          filteredPracticeIds={filteredPracticeIds}
          modelTitle="Stript Stats"
          tableTitle="Stripe Amount"
          align="end"
        />;
      case "goCardLess":
        return <DashBoardStatsModel
          modelType={DashboardStateType.GoCardLessAmount}
          open
          onCancel={() => setActiveModal(null)}
          fromDate={fromDate}
          toDate={toDate}
          filteredPracticeIds={filteredPracticeIds}
          modelTitle="GoCardLess Stats"
          tableTitle="GoCardLess Amount"
          align="end"
        />;
      default:
        return null;
    }
  };

  return (
    <>
      <Card
        key={id}
        className="hc-card"
        hoverable={hoverable}
        extra={extra}
        style={{
          lineHeight: 1.8,
          borderRadius: token.borderRadiusLG,
          ['--hc-accent' as any]: getAccent(id), ['--hc-bg' as any]: getBg(id)
        }}
        styles={{ body: { padding: "14px 16px" } }}
        onClick={() => setActiveModal(id)}
      >
        <Spin
          spinning={loading}
          indicator={<LoadingOutlined style={{ fontSize: 18, color: getAccent(id) }} spin />}
        >
          <Row align="middle" gutter={10} wrap={false}>
            {icon && <Col className="hc-icon-badge">{icon}</Col>}
            <Col flex="1" style={{ minWidth: 0 }}>
              <div className="hc-title">{title}</div>
            </Col>
          </Row>

          <Row className="hc-value">
            {value}
          </Row>
        </Spin>
      </Card>
      {renderModal()}
    </>
  );
};

// Map each card id to a subtle accent / icon background tint
const getAccent = (id: string): string => {
  const accents: Record<string, string> = {
    incoming: "#52C41A",
    outgoing: "#FF4D4F",
    emails: "#14b6b6",
    storageUses: "#7C3AED",
    invoice: "#52C41A",
    receipts: "#52C41A",
    stripe: "#1677FF",
    goCardLess: "#FAAD14",
  };
  return accents[id] || "#3F5BD3";
};

const getBg = (id: string): string => {
  const accent = getAccent(id);
  // convert hex to rgba with low opacity for the icon badge background
  const hex = accent.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r},${g},${b},0.12)`;
};

export default HeaderCard;